var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToFavouriteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_120_698)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_120_698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3C4.6868 3 2 5.73373 2 9.10648C2 11.8291 3.05 18.2909 13.3856 24.8229C13.5707 24.9387 13.7833 25 14 25C14.2167 25 14.4293 24.9387 14.6144 24.8229C24.95 18.2909 26 11.8291 26 9.10648C26 5.73373 23.3132 3 20 3C16.6868 3 14 6.70089 14 6.70089C14 6.70089 11.3132 3 8 3Z",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3C4.6868 3 2 5.73373 2 9.10648C2 11.8291 3.05 18.2909 13.3856 24.8229C13.5707 24.9387 13.7833 25 14 25C14.2167 25 14.4293 24.9387 14.6144 24.8229C24.95 18.2909 26 11.8291 26 9.10648C26 5.73373 23.3132 3 20 3C16.6868 3 14 6.70089 14 6.70089C14 6.70089 11.3132 3 8 3Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_120_698",
    x: -100,
    y: -100,
    width: 228,
    height: 228,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_120_698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_120_698",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_120_698",
    x: -3,
    y: -2,
    width: 34,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_120_698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_120_698",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToFavouriteIcon);
export default __webpack_public_path__ + "static/media/to-favourite-icon.fe22c04b399eba7897a208382813bae1.svg";
export { ForwardRef as ReactComponent };